export enum ButtonsType {
  ADD = 'ADD',
  BACK = 'BACK',
  CANCEL = 'CANCEL',
  CIRCLE_CHECK_CLASSIC_REGULAR = 'CIRCLE_CHECK_CLASSIC_REGULAR',
  EDIT = 'EDIT',
  FA_FILE_EXPORT_THIN = 'FA_FILE_EXPORT_THIN',
  FA_SQUARE_DOUTONE = 'FA_SQUARE_DOUTONE',
  FA_SQUARE_LIGHT = 'FA_SQUARE_LIGHT',
  FA_SQUARE_REGULAR = 'FA_SQUARE_REGULAR',
  PRINT = 'PRINT',
  FA_FILE_CIRCLE_PLUS = 'FA_FILE_CIRCLE_PLUS',
  FA_CHECK_SQUARE = 'FA_CHECK_SQUARE',
  FA_SQUARE = 'FA_SQUARE',
  FA_WRENCH = 'FA_WRENCH',
  FA_FILE_CIRCLE_XMARK = 'FA_FILE_CIRCLE_XMARK',
  FA_XMARK = 'FA_XMARK',
  FORWARD = 'FORWARD',
  INFO = 'INFO',
  LIST = 'LIST',
  MEMO_CIRCLE_CHECK_CLASSIC_LIGHT = 'MEMO_CIRCLE_CHECK_CLASSIC_LIGHT',
  MEMO_CIRCLE_CHECK_CLASSIC_SOLID = 'MEMO_CIRCLE_CHECK_CLASSIC_SOLID',
  MINUS = 'MINUS',
  RECEIPT = 'RECEIPT',
  REGULAR_QUESTION = 'REGULAR_QUESTION',
  SAVE = 'SAVE',
  SOLID_TRIANGLE_EXCLAMATION = 'SOLID_TRIANGLE_EXCLAMATION',
  SOLID_RIGHT_TO_BRACKET = 'SOLID_RIGHT_TO_BRACKET',
  SOLID_FILE_EXPORT = 'SOLID_FILE_EXPORT',
  SOLID_FILE_IMPORT = 'SOLID_FILE_IMPORT',
  CLOUD_DOWNLOAD = 'CLOUD_DOWNLOAD',
  TRASH = 'TRASH',
  REFRESH = 'REFRESH',
  APPROVE = 'APPROVE',
  FA_ERASER = 'FA_ERASER',
  EYE = 'EYE',
  FA_CHECK_CIRCLE = 'FA_CHECK_CIRCLE',
  CONFIRM = 'CONFIRM',
  DONE = 'DONE',
  DETAIL = 'DETAIL',
  LOCATION_DOT = 'LOCATION_DOT',
}

export enum ButtonTypes {
  BUTTON = 'button',
  SUBMIT = 'submit',
  RESET = 'reset',
}

export enum ButtonTypeColors {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  SUCCESS = 'success',
  DANGER = 'danger',
  WARNING = 'warning',
  INFO = 'info',
  DARK = 'dark',
  LINK = 'link',
  LIGHT = 'light',
}

export enum ButtonSizeEnums {
  SMALL = 'btn-sm',
  LARGE = 'btn-lg',
}
